export default __webpack_public_path__ + "static/ISO-27001-2ec3bdb23e9d87e317f8e92f6a018d8b.png";